<template>
    <button
        type="button"
        class="fixed right-3 md:right-20 bottom-12 z-40 w-12 h-12 rounded-lg bg-primary shadow-md transition-all duration-300 ease-in-out"
        :class="
            isVisible
                ? 'opacity-100 translate-y-0 pointer-events-auto'
                : 'opacity-0 tranlate-y-4 pointer-events-none'
        "
        aria-label="Scroll to top"
        @click="scrollToTop"
    >
        <i class="fas fa-arrow-up text-white"></i>
    </button>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from "vue";

const isVisible = ref(false);
const scrollThreshold = 400;

const handleScroll = () => {
    isVisible.value = window.scrollY > scrollThreshold;
};

const scrollToTop = () => {
    const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
    ).matches;

    window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion ? "auto" : "smooth",
    });
};

onMounted(() => {
    window.addEventListener("scroll", handleScroll);
});

onBeforeUnmount(() => {
    window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped lang="scss">
button {
    &:hover {
        @apply -translate-y-1 shadow-lg bg-primary-light;
    }
}
</style>
